import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import { useMemo } from 'react';
import { bindActionCreators, useControlledReducer } from '../helper';
import { reducer } from './reducer';
import { setFilterValue, setPage, setPageSize, setSorted, setColumns, setEditedRow } from './actions';
export const useConfig = (initialState, controlledState, onStateChange) => {
  const _useControlledReducer = useControlledReducer({
      reducer,
      initialState,
      controlledState,
      onStateChange
    }),
    _useControlledReducer2 = _slicedToArray(_useControlledReducer, 2),
    state = _useControlledReducer2[0],
    dispatch = _useControlledReducer2[1];
  const boundActions = useMemo(() => bindActionCreators(dispatch, {
    setFilterValue,
    setPage,
    setPageSize,
    setSorted,
    setColumns,
    setEditedRow
  }), [dispatch]);
  return [state, boundActions];
};